export enum OrderFilterId {
  Account = 'account',
  Address = 'address',
  Brand = 'brand',
  SubBrand = 'subBrand',
  Category = 'category',
  MasterCategory = 'masterCategory',
  Division = 'division',
  Gender = 'gender',
  Month = 'month',
  Year = 'year',
  Noos = 'noos',
  IsDelivered = 'isDelivered',
  isOrderDelivered = 'isOrderDelivered',
  OrderType = 'orderType',
  PlacedDate = 'placedDate',
  ProductType = 'productType',
  Color = 'color',
  InvoiceCreatedDate = 'invoiceCreatedDate',
}
